import { useId, type HTMLAttributes, type ReactNode } from 'react';
import classNames from 'classnames';
import styles from './SettingsPage.module.scss';

export const SettingsPage = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={classNames(styles['page'], className)} data-settings-page {...props} />
);

interface SettingsHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  meta?: ReactNode;
}

export const SettingsHeader = ({ title, description, actions, meta }: SettingsHeaderProps) => (
  <header className={styles['header']}>
    <div className={styles['heading']}>
      <h1>{title}</h1>
      {description && <div className={styles['description']}>{description}</div>}
      {meta && <div className={styles['meta']}>{meta}</div>}
    </div>
    {actions && <div className={styles['actions']}>{actions}</div>}
  </header>
);

interface SettingsPanelProps extends HTMLAttributes<HTMLElement> {
  title: string;
  description?: string;
  icon?: ReactNode;
}

export const SettingsPanel = ({
  title,
  description,
  icon,
  className,
  children,
  ...props
}: SettingsPanelProps) => {
  const titleId = useId();

  return (
    <section
      className={classNames(styles['panel'], className)}
      aria-labelledby={titleId}
      {...props}
    >
      <div className={styles['panelHeading']}>
        {icon && (
          <span className={styles['icon']} aria-hidden="true">
            {icon}
          </span>
        )}
        <div>
          <h2 id={titleId}>{title}</h2>
          {description && <p>{description}</p>}
        </div>
      </div>
      {children}
    </section>
  );
};
